const {
  VITE_BASE_URL: BASE_URL = "https://api.dev.randrush.com/api",
  VITE_WALLET_URL: BASE_URL_WALLET = "https://wallet.dev.randrush.com/api",
  VITE_GAME_LOTTO_ASTRAL: GAME_LOTTO_ASTRAL = "games/lotto-astral",
  VITE_LOGIN_URL: URL_LOGIN = "auth/login",
  VITE_KEYCLOAK_URL: KEYCLOAK_URL = "https://auth.randrush.com",
  VITE_KEYCLOAK_REALM: KEYCLOAK_REALM = "rrc-dev",
  VITE_REGISTER_URL: URL_REGISTER = "auth/register",
  VITE_GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID = "",
  VITE_API_GAMIFICATION: API_GAMIFICATION = "http://localhost:3000/api",
  VITE_AMPLITUDE_KEY: AMPLITUDE_KEY = "your-amplitude-key",
  VITE_META_PIXEL_ID: META_PIXEL_ID = "",
  EXPO_PRIVATE_LA_GET_SERIES: LA_GET_SERIES = "auth/register-simplified",
  VITE_BETBY_SCRIPT: URL_BETBY_SCRIPT = "https://randrush.sptpub.com/bt-renderer.min.js",
  VITE_BETBY_BRAND_ID: BETBY_BRAND_ID = "2607956534675775497",
  VITE_BETBY_THEME: BETBY_THEME = "randrush",
  VITE_GAMANZA_ENABLED: GAMANZA_ENABLED = "true",
  VITE_GAMANZA_WIDGETS_SCRIPT_URL: GAMANZA_WIDGETS_SCRIPT_URL = "",
  VITE_GAMANZA_CLIENT_ID: GAMANZA_CLIENT_ID = "",
  VITE_GAMANZA_SERVICE_URL: GAMANZA_SERVICE_URL = "",
  VITE_GAMANZA_UI_ALLOWLIST: GAMANZA_UI_ALLOWLIST = "",
  VITE_GAMANZA_PUSH_SW_URL: GAMANZA_PUSH_SW_URL = "",
  VITE_BANK_ACCOUNT_BANK_NAME: BANK_NAME = "Banco de Venezuela",
  VITE_BANK_ACCOUNT_PHONE_NUMBER: PHONE_NUMBER = "04141234567",
  VITE_RIF: RIF = "J-12345678-9",
  VITE_CHATWOOT_BASE_URL: CHATWOOT_BASE_URL = "",
  VITE_CHATWOOT_WEBSITE_TOKEN: CHATWOOT_WEBSITE_TOKEN = "",
  NODE_ENV: ENV = "development",
} = import.meta.env;

export const ConfEnv = {
  DEFAULT_CURRENCY: "ZAR",
  GOOGLE_CLIENT_ID,
  AMPLITUDE_KEY,
  META_PIXEL_ID,
  LA_GET_SERIES,
  BASE_URL: `${BASE_URL}/v1`,
  URL_BETBY_SCRIPT,
  KEYCLOAK: {
    URL: `${KEYCLOAK_URL}`,
    REALM: `${KEYCLOAK_REALM}`,
    REALM_URL: `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}`,
  },
  API_URL: {
    APP_CONFIG: `${BASE_URL}/v1/public/config`,
    API_GAMIFICATION: `${API_GAMIFICATION}/v1`,
    URL_NOTIFICATION: `${BASE_URL}/v1/user/notifications`,
    //
    URL_LOGIN: `${BASE_URL}/${URL_LOGIN}`,
    URL_GOOGLE_LOGIN: `${BASE_URL}/v1/auth/google`,
    URL_GET_USER_LAST_CONNECTION: `${BASE_URL}/v1/user/last-connection`,
    URL_REGISTER: `${BASE_URL}/${URL_REGISTER}`,
    URL_REGISTER_SIMPLIFIED: `${BASE_URL}/v1/register/simplified`,
    //
    URL_RECOVER_PASSWORD: `${BASE_URL}/v1/user/password-recovery`,
    URL_CHANGE_PASSWORD: `${BASE_URL}/v1/user/update-password`,
    URL_UPDATE_PROFILE: `${BASE_URL}/v1/user/update-profile`,
    URL_USER_PROFILE: `${BASE_URL}/v1/user/profile`,
    URL_IDENTITY_VALIDATE: `${BASE_URL}/v1/public/identity/validate`,
    URL_UPDATE_CHILEAN_RUT: `${BASE_URL}/v1/user/chilean-rut`,
    URL_GET_USER_INFO: `${BASE_URL}/v1/user/get-info`,
    URL_CHATWOOT_IDENTITY: `${BASE_URL}/v1/user/chatwoot-identity`,
    URL_RESEND_EMAIL_VERIFICATION: `${BASE_URL}/v1/user/resend-verification`,
    API_LOTTO_ASTRAL_SERIES: `${BASE_URL}/v1/${GAME_LOTTO_ASTRAL}/series`,
    API_LOTTO_ASTRAL_TICKETS: `${BASE_URL}/v1/${GAME_LOTTO_ASTRAL}/tickets`,
    //
    API_REFERRAL: `${BASE_URL}/v1/user/referral`,
    //
    GAMES_LIST: `${BASE_URL}/v1/public/games/list`,
    GAMES_PAGINATED: `${BASE_URL}/v1/public/games/paginated`,
    TOP_REFERRALS: `${BASE_URL}/v1/public/referrals/top`,
    PIXMOVE_CONFIG: `${BASE_URL}/${import.meta.env.VITE_PIXMOVE_URL}/games/init`,
    GAMES_INIT: `${BASE_URL}/${import.meta.env.VITE_GAMES}/init`,
    // Lottery
  },
  API_CONTACT: {
    ADD_CONTACT: `${BASE_URL}/v1/user/contacts/create`,
    GET_CONTACT: `${BASE_URL}/v1/user/contacts/search`,
    LIST_CONTACT: `${BASE_URL}/v1/user/contacts/list`,
    DELETE_CONTACT: `${BASE_URL}/v1/user/contacts/delete`,
    UPDATE_CONTACT: `${BASE_URL}/v1/user/contacts/update`,
  },
  API_REFERRAL: {
    MY_REFERRAL_LINK: `${BASE_URL_WALLET}/v1/referrals/my-link`,
    MY_REFERRALS_STATS: `${BASE_URL_WALLET}/v1/referrals/my-stats`,
    MY_REFERRALS: `${BASE_URL_WALLET}/v1/referrals/my-referred-users`,
    REFERRAL_CODE: `${BASE_URL_WALLET}/v1/referrals/connect`,
  },
  API_GAMES: {
    BASE: `${BASE_URL}/v1/games`,
    ADD_FAVORITE_GAME: `${BASE_URL}/v1/games/favorite`,
    LIST_FAVORITE_GAME: `${BASE_URL}/v1/games/favorite`,
    DELETE_FAVORITE_GAME: `${BASE_URL}/v1/games/favorite`,
    LIST_RECENT_GAMES: `${BASE_URL}/v1/games/recent`,
    TOP_GAMES: `${BASE_URL}/v1/games/top`,
    NEWEST: `${BASE_URL}/v1/public/games/newest`,
  },
  API_WALLET: {
    URL_WALLET: `${BASE_URL_WALLET}/v1/user/wallet`,
    URL_PAGO_MOVIL: `${BASE_URL_WALLET}/v1/user/pago-movil-account`,
    URL_TOP_UP: import.meta.env.VITE_WALLET_TOP_UP,
    URL_PAGO_MOVIL_VERIFY: `${BASE_URL_WALLET}/v1/user/pagomovil/topup-verify`,
    URL_PAGO_MOVIL_ORPHAN_CLAIMS: `${BASE_URL_WALLET}/v1/user/pago-movil/orphan-claims`,
    URL_WITHDRAWAL: `${BASE_URL_WALLET}/v1/user/pagomovil/withdrawal`,
    URL_TRANSFER: `${BASE_URL_WALLET}/v1/user/send-money`,
    URL_TRANSACTION_HISTORY: `${BASE_URL_WALLET}/v1/user/transaction-history`,
    URL_GAMING_TRANSACTIONS: `${BASE_URL_WALLET}/v1/user/gaming-transactions`,
    URL_WITHDRAWAL_LIMIT: `${BASE_URL_WALLET}/v1/user/withdrawal-limits`,
    URL_DEPOSIT: `${BASE_URL_WALLET}/v1/user/pagomovil/bdv/consolidate`,
    URL_BINANCE_DEPOSIT: `${BASE_URL_WALLET}/v1/user/zpay24/deposit/usdt`,
    URL_BINANCE_TRANSACTION_STATUS: `${BASE_URL_WALLET}/v1/user/zpay24/transaction/order`,
    URL_BINANCE_WITHDRAWAL: `${BASE_URL_WALLET}/v1/user/zpay24/withdrawal/usdt`,
    URL_PAYKU_DEPOSIT: `${BASE_URL_WALLET}/v1/user/zpay24/deposit/payku/clp`,
    URL_PAYKU_TRANSACTION_STATUS: `${BASE_URL_WALLET}/v1/user/zpay24/transaction/status`,
    URL_PAYKU_WITHDRAWAL: `${BASE_URL_WALLET}/v1/user/zpay24/withdrawal/payku`,
    URL_PAYKU_BANKS: `${BASE_URL_WALLET}/v1/user/zpay24/banks/payku`,
    URL_CHILEAN_BANK_ACCOUNT: `${BASE_URL_WALLET}/v1/user/chilean-bank-account`,
    URL_CHILEAN_BANK_ACCOUNTS: `${BASE_URL_WALLET}/v1/user/chilean-bank-accounts`,
    URL_BALANCE_BONUS: `${BASE_URL_WALLET}/v1/user/balance-bonus`,
  },
  BASE_URL_WALLET: BASE_URL_WALLET,
  API_USERS: {
    PROFILE: `${BASE_URL}/v1/users`,
  },
  API_BETBY: {
    URL_TOKEN: `${BASE_URL}/v1/betby/user/token`,
    BRAND_ID: BETBY_BRAND_ID,
    THEME: BETBY_THEME,
  },
  GAMANZA: {
    ENABLED: GAMANZA_ENABLED === "true",
    // v2 widgets bundle script (from your region CDN), e.g.:
    // https://{cdn-region}.gamanzaengage.com/casino-ui-widgets-v2/bundle.v2.min.js
    WIDGETS_SCRIPT_URL: GAMANZA_WIDGETS_SCRIPT_URL,
    // Gamanza Engage Admin FE client id (used in /api/auth/v1/player)
    CLIENT_ID: GAMANZA_CLIENT_ID,
    // Frontend API gateway base URL used by widgets (PEP_FE serviceUrl)
    SERVICE_URL: GAMANZA_SERVICE_URL,
    // Comma-separated emails. Non-empty = only those users see Gamanza UI
    // (BO flag ignored). Empty = fall back to featureFlags.gamanzaEnabled.
    UI_ALLOWLIST: GAMANZA_UI_ALLOWLIST,
    // Optional. Defaults to same CDN folder as WIDGETS_SCRIPT_URL + gamanza-service-worker.min.js
    PUSH_SW_URL: GAMANZA_PUSH_SW_URL,
  },
  ENV,

  // Public Website Inbox config (not secrets). The identity HMAC lives only in ryg-core.
  CHATWOOT: {
    BASE_URL: CHATWOOT_BASE_URL.replace(/\/+$/, ""),
    WEBSITE_TOKEN: CHATWOOT_WEBSITE_TOKEN,
  },

  BANK_ACCOUNT: {
    BANK_NAME,
    RIF,
    PHONE_NUMBER,
  },
  PAGINATION: {
    PAGE: 1,
    LIMIT: 10,
  },
  API_BANNERS: {
    URL_BANNERS: `${BASE_URL}/v1/public/banners`,
  },
  API_CAROUSELS: {
    URL_CAROUSELS: `${BASE_URL}/v1/carousels`,
  },
  API_CUSTOM_BOARDS: {
    URL: `${BASE_URL}/v1/custom-boards`,
  },
  API_HOME_SECTIONS: {
    URL: `${BASE_URL}/v1/home-sections`,
  },
  API_GAME_FEED: {
    FEED_LIST: `${BASE_URL}/v1/game-feed`,
    PROVIDER_FEED: `${BASE_URL}/v1/game-feed/provider`,
    TOGGLE_FOLLOW: `${BASE_URL}/v1/game-feed/provider/follow`,
    LIST_FOLLOWED_PROVIDERS: `${BASE_URL}/v1/game-feed/provider/follow`,
    TOGGLE_LIKE: `${BASE_URL}/v1/game-feed/like`,
    COMMENTS: `${BASE_URL}/v1/game-feed/comments`,
  },
};

export const SocialMedia = {
  FACEBOOK: "https://www.facebook.com/randrush",
  INSTAGRAM: "https://www.instagram.com/randrush/",
  X: "https://www.x.com/",
  TIKTOK: "https://www.tiktok.com/@randrush",
};

export const DownloadApp = {
  ANDROID: "https://play.google.com/store/apps/details?id=com.randrush.app",
  IOS: "https://apps.apple.com/",
};
